import React from "react";
import find from "lodash/find";
import get from "lodash/get";
import set from "lodash/set";
import assign from "lodash/assign";
import moment from "moment-timezone";
import Sticky from "react-stickynode";
import { rrulestr, RRule } from "rrule";
import chrono from "chrono-node";
import {
  IconButton,
  CircularProgress,
  RaisedButton,
  TextField,
  Checkbox,
  FlatButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import { Link } from "react-router";
import update from "immutability-helper";
import Codemirror from "react-codemirror";
import "codemirror/mode/htmlmixed/htmlmixed";

import HtmlEditor from "./partials/html-editor.jsx";
import ImageDropzone from "./partials/image-dropzone.jsx";
import TicketBucketsEditor from "./partials/ticket-buckets-editor.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import Label from "./partials/label.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import BackButton from "./partials/back-button.jsx";
import LinkLike from "./partials/link-like.jsx";
import SchedulerOverlay, {
  appendTimeZone
} from "./partials/overlays/scheduler-overlay.jsx";
import DateTimeField from "./partials/datetime-field.jsx";
import { timezoneDelta } from "./partials/datetime-picker.jsx";
import { Status as FilmStatus } from "./partials/film-table.jsx";
import SelectWells from "./partials/select-wells.jsx";
import DurationField from "./partials/duration-field.jsx";
import BasicHtmlField from "./partials/basic-html-field.jsx";
import ViewLiveVirtualButton from "./partials/view-live-virtual-button.jsx";

import LocalMoviesIcon from "material-ui/svg-icons/maps/local-movies";
import EventIcon from "material-ui/svg-icons/action/event";
import DateRangeIcon from "material-ui/svg-icons/action/date-range";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import CopyIcon from "material-ui/svg-icons/content/content-copy";

import connectToStores from "alt-utils/lib/connectToStores";
import EventActions from "../actions/EventActions";
import EventStore from "../stores/EventStore";
import VenueStore from "../stores/VenueStore";
import FilmStore from "../stores/FilmStore";
import UserStore from "../stores/UserStore";
import EventBucketStore from "../stores/EventBucketStore";
import { makeEventDateRangeLabel } from "../util";

const capitalize = e => e && e.length && e.charAt(0).toUpperCase() + e.slice(1);

import EventivalBanner from "./partials/eventival-banner.jsx";
import DisplayAdEditor from "./display-ad-editor.jsx";
import RevenueSharingEditor from "./partials/revenue-sharing-editor.jsx";
import RecurringUpdateModal from "./partials/events/recurring-update-modal.jsx";
import PassRulesEditorNonAtomic from "./partials/pass-rules-editor-nonatomic.jsx";
import VirtualContentEditor from "./partials/virtual-content-editor.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import VirtualContentStore from "../stores/VirtualContentStore.js";

class Event extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "", // film / undated / default
      event: {},
      dirty: false,
      isSaving: false,
      lastUpdatedAt: false,
      isUploadingImage: false,
      oldImage: null,
      hasReservedSeating: true,
      hasVenueChanged: false,
      oldVenue: null,
      htmlRawMode: false,
      values: {},
      showExternalTicketsUrl: false,
      showScheduler: false,
      showRecurringUpdateModal: false,
      showRecurringDeleteModal: false,
      showTermsEditor: false
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onTagsChange = this.onTagsChange.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onExternalTicketsUrlCheck = this.onExternalTicketsUrlCheck.bind(this);
    this.onTicketsButtonLabelCheck = this.onTicketsButtonLabelCheck.bind(this);
    this.save = this.save.bind(this);
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.duplicate = this.duplicate.bind(this);
  }

  static getStores() {
    return [EventStore, EventBucketStore, VirtualContentStore];
  }

  static getPropsFromStores() {
    return {
      getEventById: EventStore.getEventById,
      uploadingImageField: EventStore.getState().uploadingImageField
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        background: "white",
        display: "flex",
        alignItems: "center"
      },
      title: {
        display: "inline-block",
        marginLeft: 20,
        flexGrow: 1
      },
      subtitle: {
        fontSize: "0.5em",
        fontWeight: "normal",
        marginTop: 5,
        lineHeight: 1.3
      },
      label: {
        color: "rgba(33, 33, 33, 0.498039)",
        fontSize: 12,
        marginTop: 10,
        marginBottom: 5
      },
      editor: {
        marginTop: 40
      },
      editorHeader: {
        borderBottom: "1px solid #e6e6e6",
        paddingBottom: 5,
        marginBottom: 15
      },
      dropzone: {
        width: 200,
        padding: 20,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      progress: {
        marginBottom: 50
      },
      h3: {
        margin: "15px 0 10px"
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined"
        ? !get(this.state.values, id)
        : e.target.value
    );
  }

  onChangeValue(id, value, cb) {
    // If editing the start time, apply the same delta transformation to the end time.
    const transformDelta = (start_time_name, end_time_name) => {
      if (id === start_time_name && value) {
        let oldStart = get(this.state.values, start_time_name);
        let oldEndTime = get(this.state.values, end_time_name);
        set(
          this.state.values,
          end_time_name,
          oldEndTime
            ? oldEndTime.add(value.diff(oldStart))
            : moment(value).add(2, "hours")
        );
      }
    };
    transformDelta("start_time", "end_time");
    transformDelta("_livestream_film.start_time", "_livestream_film.end_time");

    // Copy over values to _livestream_film.
    if (this.state.mode === "live") {
      if (id === "name") {
        set(this.state.values, `_livestream_film.name`, value);
      }
      if (id === "short_description") {
        set(this.state.values, `_livestream_film.short_description`, value);
      }
    }

    set(this.state.values, id, value);
    this.setState(
      {
        dirty: true,
        values: this.state.values
      },
      cb
    );
  }

  onChangeValueAsync(id, value) {
    return new Promise((resolve, reject) => {
      this.onChangeValue(id, value, () => resolve());
    });
  }

  onArrayItemShiftPosition(id, index, direction) {
    let arr = [...this.state.values[id]];
    arr.splice(index + direction, 0, arr.splice(index, 1)[0]);
    this.setState({
      dirty: true,
      values: update(this.state.values, { [id]: { $set: arr } })
    });
  }

  onArrayItemAdd(id, value) {
    this.setState({
      dirty: true,
      values: update(this.state.values, { [id]: { $push: [value] } })
    });
  }

  onArrayItemEdit(id, index, value) {
    this.setState({
      dirty: true,
      values: update(this.state.values, { [id]: { [index]: { $set: value } } })
    });
  }

  onArrayItemDelete(id, index) {
    this.setState({
      dirty: true,
      values: update(this.state.values, { [id]: { $splice: [[index, 1]] } })
    });
  }

  // requires an array of additions and an array of delete indexes
  onArrayItemAddAndDelete(id, additions, delIndexes) {
    //sort indexes descending
    delIndexes.sort(function (a, b) {
      return b - a;
    });
    //process indexes (after descending sort to ensure index structure remains intact)
    let newData = this.state.values;
    for (let x = 0; x < delIndexes.length; x++) {
      newData = update(newData, { [id]: { $splice: [[delIndexes[x], 1]] } });
    }
    //add additions all at once as an array
    const addData = update(newData, { [id]: { $push: additions } });
    this.setState({
      dirty: true,
      values: addData
    });
  }

  onTagsChange(tags) {
    this.onChangeValue("tags", tags);
  }

  async onModeChange(mode) {
    if (this.state.event.is_virtual) {
      if (mode === "live") {
        await this.onChangeValueAsync("films", []);
        // Update values to go to _livestream_film
        await this.onChangeValueAsync("name", this.state.values.name);
        await this.onChangeValueAsync(
          "short_description",
          this.state.values.short_description
        );
      }
      if (mode === "film") {
        await this.onChangeValueAsync("_livestream_film", {});
      } else {
        if (mode === "live" || mode === "combo") {
          await this.onChangeValueAsync(
            "_livestream_film.livestream_mode",
            "eventive"
          );
        }
      }
      if (mode === "vod") {
        await this.onChangeValueAsync("_livestream_film", false);
      }
      return;
    }

    await this.onChangeValueAsync("is_dated", mode !== "undated");
    if (mode !== "film") {
      await this.onChangeValueAsync("films", []);
    }
  }

  async onRRuleChange({ repeats, applyRecurring }, cb) {
    let values = {
      ...this.state.values,
      recurring_event: {
        repeats
      }
    };

    values.start_time = values.start_time && values.start_time.toISOString();
    values.end_time = values.end_time && values.end_time.toISOString();

    if (applyRecurring) {
      this.setState({
        isSaving: true,
        lastUpdatedAt: this.state.event.updated_at
      });
      await EventActions.edit.defer(
        this.props.params.eventId,
        values,
        applyRecurring
      );
    } else {
      throw "Error: applyRecurring is not defined.";
    }
    window.scrollTo(0, 0);
    cb();
  }

  onDrop(id, file) {
    this.onChangeValue(id, undefined);
    EventActions.editImage.defer(this.props.params.eventId, id, file);
  }

  onExternalTicketsUrlCheck(e) {
    this.setState(
      {
        showExternalTicketsUrl: !this.state.showExternalTicketsUrl
      },
      () => {
        this.onChangeValue("external_tickets_url", "");
      }
    );
  }

  onTicketsButtonLabelCheck(e) {
    this.setState(
      {
        showTicketsButtonLabel: !this.state.showTicketsButtonLabel
      },
      () => {
        this.onChangeValue("tickets_button_label", "");
      }
    );
  }

  _updateFilms(filmIds) {
    let originalIds = this.state.values.films,
      hasLivestream = false;

    if (
      this.state.values._livestream_film &&
      this.state.values._livestream_film.id
    ) {
      hasLivestream = true;
      filmIds.push(this.state.values._livestream_film.id);
    }

    this.onChangeValue("films", filmIds, () => {
      let originalDetails = originalIds.map(id => FilmStore.getFilmById(id));
      let details = filmIds.map(id => FilmStore.getFilmById(id));
      this.setState(
        {
          filmDetails: details
        },
        () => {
          if (
            !hasLivestream &&
            details.length <= 2 &&
            (this.state.values.name.indexOf("Unnamed") === 0 ||
              this.state.values.name ===
                originalDetails.map(d => d.name).join(" & "))
          ) {
            this.onChangeValue("name", details.map(d => d.name).join(" & "));
          }
        }
      );
    });
  }

  save({ applyRecurring } = {}) {
    var values = assign({}, this.state.values);

    values.start_time = values.start_time && values.start_time.toISOString();
    values.end_time = values.end_time && values.end_time.toISOString();
    if (values._livestream_film) {
      values._livestream_film.start_time =
        values._livestream_film.start_time &&
        values._livestream_film.start_time.toISOString();
      values._livestream_film.end_time =
        values._livestream_film.start_time &&
        values._livestream_film.end_time.toISOString();
    }

    if (this.state.event.recurring_event && !applyRecurring) {
      this.setState({ showRecurringUpdateModal: true });
      return;
    }

    this.setState({
      isSaving: true,
      lastUpdatedAt: this.state.event.updated_at,
      showRecurringUpdateModal: false
    });
    if (applyRecurring) {
      EventActions.edit.defer(
        this.props.params.eventId,
        values,
        applyRecurring
      );
    } else {
      EventActions.edit.defer(this.props.params.eventId, values);
    }
  }

  deleteConfirm() {
    if (this.state.event.recurring_event) {
      this.setState({ showRecurringDeleteModal: true });
    } else if (
      window.confirm(
        `Are you sure you want to DELETE "${this.state.event.name}"? The screening will be PERMANENTLY DESTROYED and cannot be recovered.`
      )
    ) {
      this.delete();
    }
  }

  delete({ applyRecurring } = {}) {
    let isVirtual = this.state.event.is_virtual;
    let bucket = this.state.event.event_bucket;
    this.setState({ dirty: false }, () => {
      EventActions.delete(this.props.params.eventId, applyRecurring);
      this.context.router.push(
        `/event_buckets/${bucket}${isVirtual ? "/virtual_festival" : "/events"}`
      );
    });
  }

  duplicate() {
    if (
      window.confirm(
        `Are you sure you want to duplicate "${this.state.event.name}"? All ticket buckets will be duplicated as well.`
      )
    ) {
      EventActions.duplicate(this.props.params.eventId);
      this.context.router.push(
        `/event_buckets/${
          this.props.params.eventBucketId
        }/events/new?duplicate=true${
          this.state.event.is_virtual ? "&virtual=true" : ""
        }`
      );
    }
  }

  componentDidMount() {
    this.context.router.setRouteLeaveHook(this.props.route, () => {
      if (this.state.dirty) {
        return "Are you sure you wish to leave the event editor? Your changes will not be saved.";
      }
    });

    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var event = newProps.getEventById(newProps.params.eventId);

    if (!this.state.isFetchingEvent && (!event || !event.public_url)) {
      EventActions.fetchOne.defer(newProps.params.eventId);
      this.setState({ isFetchingEvent: true });
    } else if (event && event.public_url) {
      this.setState({ isFetchingEvent: false, event });
    }

    // Short circuit if event not ready yet
    if (!event || !event.public_url) {
      return;
    }

    let liveFilm = event && find(event.films, f => f.type === "livestream");
    if (event && !this.state.mode) {
      if (event.is_virtual) {
        let hasVod = event.films.some(
          f => !f.virtual_content || f.virtual_content.type !== "livestream"
        );
        let hasLive = !!liveFilm;
        this.setState({
          mode:
            hasVod && hasLive
              ? "combo"
              : hasVod
              ? "vod"
              : hasLive
              ? "live"
              : null
        });
      } else if (
        event.films.length ||
        (this.state.values.films && this.state.values.films.length)
      ) {
        this.setState({ mode: "film" });
      } else if (!event.is_dated) {
        this.setState({ mode: "undated" });
      } else if (
        (event.name && event.name !== "Unnamed Event") ||
        event.description ||
        event.short_description
      ) {
        this.setState({ mode: "default" });
      }
    }

    if (
      Object.keys(this.state.values).length === 0 ||
      this.state.event.id !== newProps.params.eventId ||
      (this.state.isSaving && event.updated_at !== this.state.lastUpdatedAt)
    ) {
      this.setState({ oldVenue: event.venue.id, hasReservedSeating: event.venue.use_reserved_seating, hasVenueChanged: false });
      this.setState({
        event,
        dirty: false,
        isSaving: false,
        showExternalTicketsUrl: event && !!event.external_tickets_url,
        showTicketsButtonLabel: event && !!event.tickets_button_label,
        showGeographicRestrictions: event
          ? event.geographic_restrictions.length
            ? "geographic_restrictions"
            : event.geographic_exclusions.length
            ? "geographic_exclusions"
            : null
          : undefined,
        values: event
          ? {
              name: event.name || "",
              films: event.films ? event.films.map(f => f.id) : [],
              description: event.description || "",
              short_description: event.short_description || "",
              venue: event.venue.id,
              is_dated: event.is_dated,
              start_time: event.start_time
                ? moment.tz(event.start_time, event.timezone)
                : moment
                    .tz(Date.now(), event.timezone)
                    .startOf("day")
                    .add(10, "days")
                    .add(19, "hours"),
              end_time: event.end_time
                ? moment.tz(event.end_time, event.timezone)
                : moment
                    .tz(Date.now(), event.timezone)
                    .startOf("day")
                    .add(10, "days")
                    .add(21, "hours"),
              hide_tickets_button: event.hide_tickets_button,
              tickets_button_label: event.tickets_button_label,
              external_tickets_url: event.external_tickets_url,
              trailer_url: event.trailer_url,
              display_ad_url: event.display_ad_url,
              visibility: event.visibility,
              custom_email_text: event.custom_email_text,
              passholder_ticket_required: event.passholder_ticket_required,
              standalone_ticket_sales_enabled:
                event.standalone_ticket_sales_enabled,
              standalone_ticket_sales_unlocked:
                event.standalone_ticket_sales_unlocked,
              sales_disabled_unless_coupon: event.sales_disabled_unless_coupon,
              cutoff_event_watch_at_availability_end: event.cutoff_event_watch_at_availability_end,
              require_mailing_address: event.require_mailing_address,
              require_phone_number: event.require_phone_number,
              credits_disabled: event.credits_disabled,
              aarp_member_required: event.aarp_member_required,
              geographic_restrictions: event.geographic_restrictions || [],
              geographic_exclusions: event.geographic_exclusions || [],
              show_in_coming_soon: event.show_in_coming_soon,
              allow_preorder: event.allow_preorder,
              show_quantity_countdown: event.show_quantity_countdown,
              virtual_balloting_enabled: event.virtual_balloting_enabled,
              virtual_balloting_inline_during_playback:
                event.virtual_balloting_inline_during_playback,
              tags: event.tags.map(t => t.id),
              custom_id: event.custom_id,
              ticket_buckets: event.ticket_buckets || [],
              use_default_event_bucket_preroll:
                event.use_default_event_bucket_preroll === undefined
                  ? true
                  : event.use_default_event_bucket_preroll,
              virtual_content_preroll: event.virtual_content_preroll,
              virtual_content_preroll_visible:
                event.virtual_content_preroll_visible === undefined
                  ? true
                  : event.virtual_content_preroll_visible,
              use_default_event_bucket_postroll:
                event.use_default_event_bucket_postroll === undefined
                  ? true
                  : event.use_default_event_bucket_postroll,
              virtual_content_postroll: event.virtual_content_postroll,
              virtual_content_postroll_visible:
                event.virtual_content_postroll_visible === undefined
                  ? true
                  : event.virtual_content_postroll_visible,
              virtual_show_donate_prompt: event.virtual_show_donate_prompt,
              virtual_intervals: event.virtual_intervals,
              virtual_donate_message: event.virtual_donate_message,
              virtual_realtime_broadcast_film:
                event.virtual_realtime_broadcast_film,
              virtual_realtime_broadcast_become_vod_afterwards:
                event.virtual_realtime_broadcast_become_vod_afterwards,
              rules: event.rules || [],
              _livestream_film: liveFilm
                ? {
                    id: liveFilm.id,
                    name: liveFilm.name,
                    short_description: liveFilm.short_description,
                    description: liveFilm.description,
                    start_time: liveFilm.start_time
                      ? moment.tz(liveFilm.start_time, event.timezone)
                      : undefined,
                    end_time: liveFilm.end_time
                      ? moment.tz(liveFilm.end_time, event.timezone)
                      : undefined,
                    livestream_mode: liveFilm.livestream_mode,
                    livestream_embed_code: liveFilm.livestream_embed_code,
                    livestream_external_instructions:
                      liveFilm.livestream_external_instructions
                  }
                : undefined,
              terms_at_checkout: event.terms_at_checkout,
              revenue_share: event.revenue_share
            }
          : {}
      });
    }
  }

  renderExternalTicketsUrl() {
    return (
      <div>
        <Checkbox
          label={"Sell tickets on external site"}
          checked={this.state.showExternalTicketsUrl}
          onCheck={this.onExternalTicketsUrlCheck}
        />
        {this.state.showExternalTicketsUrl ? (
          <TextField
            value={this.state.values.external_tickets_url || ""}
            floatingLabelText="External tickets url"
            floatingLabelFixed={true}
            placeholder="https://ticketwebsite.com/123456"
            style={{ marginTop: "-0.75em", marginLeft: "2.5em" }}
            onChange={e =>
              this.onChangeValue("external_tickets_url", e.target.value)
            }
          />
        ) : null}
      </div>
    );
  }

  render() {
    var styles = this.getStyles(),
      { isSaving, htmlRawMode, isFetchingEvent, event } = this.state;

    const showTermsEditor =
      !!this.state.values.terms_at_checkout || this.state.showTermsEditor;

    const isVirtualExpired =
      event &&
      event.is_virtual &&
      !UserStore.isGod() &&
      (UserStore.getUser() || {}).virtual_festival_plan_status === "expired";

    if (isFetchingEvent && (!event || !event.public_url)) {
      return <WorkingIndicator fullPage={true} />;
    }

    const eventBucket =
      EventBucketStore.getEventBucketById(this.props.params.eventBucketId) ||
      {};

    return (
      <div style={{ marginTop: -20 }}>
        <Sticky top="#eventive-app-bar" innerZ={50}>
          <div style={styles.actions} id="eventive-event-editor-bar">
            <BackButton
              label={
                this.props.location.state &&
                this.props.location.state.fromListing
                  ? event.is_virtual
                    ? "virtual screenings"
                    : "events"
                  : event.is_virtual
                  ? "screening"
                  : "event"
              }
              style={{ marginRight: 7, flexShrink: 0, marginTop: -1 }}
              onTouchTap={() =>
                this.props.location.state &&
                this.props.location.state.fromListing
                  ? this.context.router.goBack()
                  : this.context.router.push(
                      `/event_buckets/${this.props.params.eventBucketId}${
                        event.is_virtual ? "/virtual_festival" : ""
                      }/events/${this.props.params.eventId}`
                    )
              }
            />
            <h1 style={styles.title}>
              {this.state.values.name}
              <div style={styles.subtitle}>
                {makeEventDateRangeLabel({
                  ...this.state.event,
                  ...this.state.values
                })}
              </div>
            </h1>
            {isVirtualExpired ? (
              <div style={{ flexShrink: 0 }}>
                <RaisedButton
                  label="Cannot save since Eventive Virtual expired – contact us"
                  disabled
                />
              </div>
            ) : (
              <div style={{ flexShrink: 0 }}>
                <IconButton
                  tooltip={
                    !this.state.dirty &&
                    (event.is_virtual
                      ? "Duplicate screening"
                      : "Duplicate event")
                  }
                  onTouchTap={this.duplicate}
                  disabled={this.state.dirty}
                >
                  <CopyIcon />
                </IconButton>
                <IconButton
                  tooltip={
                    event.is_virtual ? "Delete screening" : "Delete event"
                  }
                  onTouchTap={this.deleteConfirm}
                  style={{ marginLeft: -12 }}
                >
                  <DeleteIcon />
                </IconButton>
                {!this.state.dirty ? (
                  event.is_virtual ? (
                    <ViewLiveVirtualButton
                      style={{
                        marginRight: 12,
                        marginLeft: 6,
                        verticalAlign: 8
                      }}
                      label="View live"
                      href={this.state.event.public_url}
                    />
                  ) : (
                    <RaisedButton
                      style={{
                        marginRight: 12,
                        marginLeft: 6,
                        verticalAlign: 10
                      }}
                      label="View live"
                      href={event.public_url}
                      target="_blank"
                    />
                  )
                ) : null}
                <RaisedButton
                  label={
                    isSaving
                      ? "Saving..."
                      : this.state.dirty
                      ? "Save changes"
                      : "No changes to save"
                  }
                  primary={true}
                  disabled={!this.state.dirty || isSaving}
                  onTouchTap={this.save}
                  style={{ marginLeft: 6, verticalAlign: 8 }}
                />
              </div>
            )}
          </div>
        </Sticky>
        {isSaving && <WorkingIndicator fullPage={true} overlay={true} />}
        {this.state.showScheduler ? (
          <SchedulerOverlay
            timezone={this.state.event.timezone}
            repeats={
              this.state.event.recurring_event &&
              this.state.event.recurring_event.repeats
            }
            start_time={this.state.values.start_time}
            end_time={this.state.values.end_time}
            name={this.state.values.name}
            onChange={(e, cb) => this.onRRuleChange(e, cb)}
            onRequestClose={() => this.setState({ showScheduler: false })}
          />
        ) : null}
        {this.state.showRecurringUpdateModal ? (
          <RecurringUpdateModal
            title="Edit recurring event"
            buttonTitle="Save"
            onSave={applyRecurring => this.save({ applyRecurring })}
            onRequestClose={() =>
              this.setState({ showRecurringUpdateModal: false })
            }
          />
        ) : null}
        {this.state.showRecurringDeleteModal ? (
          <RecurringUpdateModal
            title="Delete recurring event"
            buttonTitle="Submit"
            onSave={applyRecurring => this.delete({ applyRecurring })}
            onRequestClose={() =>
              this.setState({ showRecurringDeleteModal: false })
            }
          />
        ) : null}
        <div style={{ marginTop: -20 }}>
          {this.state.event.eventival_id && (
            <EventivalBanner
              type="event"
              style={{ marginTop: 20, marginBottom: -10 }}
            />
          )}
          <InfoNotice style={{ marginTop: 20 }}>
            Check out our{" "}
            {event.is_virtual ? (
              <a
                href="http://help.eventive.org/en/articles/3987519-create-virtual-screenings"
                target="_blank"
              >
                guide to creating virtual screenings
              </a>
            ) : (
              <a
                href="http://help.eventive.org/events-and-tickets/create-events"
                target="_blank"
              >
                guide to creating events
              </a>
            )}
            .
          </InfoNotice>
        </div>
        {!event.is_virtual ? (
          <div style={{ marginTop: "1em" }}>
            <Label>Event type</Label>
            <SelectWells
              style={{ maxWidth: "calc(517px + 1em)" }}
              options={[
                {
                  value: "film",
                  icon: LocalMoviesIcon,
                  label: "Film showing"
                },
                {
                  value: "default",
                  icon: EventIcon,
                  label: "Other event"
                },
                {
                  value: "undated",
                  icon: DateRangeIcon,
                  label: "Undated event"
                }
              ]}
              onChange={v =>
                this.setState({ mode: v }, () => this.onModeChange(v))
              }
              value={this.state.mode}
            />
          </div>
        ) : (
          <div style={{ margin: "1em 0" }}>
            <Label>Virtual screening type</Label>
            <SelectWells
              style={{ maxWidth: "calc(750px + 1em)" }}
              options={[
                {
                  value: "vod",
                  icon: LocalMoviesIcon,
                  label: "Video on Demand"
                },
                {
                  value: "live",
                  icon: EventIcon,
                  label: "Livestream"
                },
                {
                  value: "combo",
                  icon: DateRangeIcon,
                  label: "VOD + Live"
                }
              ]}
              onChange={v => {
                let ok =
                  v !== "vod" ||
                  ["live", "combo"].indexOf(this.state.mode) === -1 ||
                  window.confirm(
                    "Are you sure you would like to remove the livestream from this screening? You CANNOT re-attach it."
                  );
                if (ok) {
                  this.setState({ mode: v }, () => this.onModeChange(v));
                }
              }}
              value={this.state.mode}
            />
          </div>
        )}
        {(event.is_virtual &&
          (this.state.mode === "vod" || this.state.mode === "combo")) ||
        this.state.mode === "film" ? (
          <div style={{ marginTop: "2em" }}>
            <InjectedSelect
              label="Film(s)"
              placeholder="Select one or more films..."
              value={this.state.values.films}
              type="films"
              multi={true}
              noResultsText={
                event.is_virtual ? (
                  <span>
                    No films with virtual content found. Use the{" "}
                    <Link
                      to={`event_buckets/${this.props.params.eventBucketId}/films`}
                    >
                      Films
                    </Link>{" "}
                    section to create new films, and ensure content creators
                    have uploaded virtual content.
                  </span>
                ) : (
                  <span>
                    No films found. Use the{" "}
                    <Link
                      to={`event_buckets/${this.props.params.eventBucketId}/films`}
                    >
                      Films
                    </Link>{" "}
                    section to create new films.
                  </span>
                )
              }
              labelToFilterString={f => f.name}
              labelFormatter={
                event.is_virtual
                  ? f => {
                      return (
                        <span>
                          {f.name}{" "}
                          <span style={{ fontSize: "0.9em" }}>
                            {" "}
                            &middot; <FilmStatus film={f} detailed inWidget />
                          </span>
                        </span>
                      );
                    }
                  : f => f.name
              }
              filterBy={
                event.is_virtual
                  ? f =>
                      f.type !== "livestream" &&
                      (!f.virtual_content ||
                        f.virtual_content.type !== "livestream")
                  : undefined
              }
              eventBucketId={this.props.params.eventBucketId}
              style={{ maxWidth: 517 }}
              closeOnSelect={true}
              onChange={selected => {
                this._updateFilms(selected);
              }}
            />
          </div>
        ) : null}

        {(event.is_virtual && this.state.mode) ||
        (this.state.mode === "film" && this.state.values.films.length) ||
        this.state.mode === "undated" ||
        this.state.mode === "default" ? (
          <div>
            <div>
              <TextField
                value={get(this.state, "values.name", "")}
                floatingLabelText={
                  event.is_virtual ? "Virtual listing title" : "Event name"
                }
                floatingLabelFixed={true}
                style={{ width: "100%", maxWidth: 517 }}
                onChange={e => this.onChangeValue("name", e.target.value)}
              />
            </div>
            {(
              EventBucketStore.getEventBucketById(
                this.props.params.eventBucketId
              ) || {}
            ).enable_custom_event_ids ? (
              <div>
                <TextField
                  value={get(this.state, "values.custom_id", "")}
                  floatingLabelText="Custom event ID"
                  floatingLabelFixed={true}
                  style={{ width: "100%", maxWidth: 517 }}
                  onChange={e =>
                    this.onChangeValue("custom_id", e.target.value)
                  }
                />
              </div>
            ) : null}

            {event.is_virtual &&
            ["live", "combo"].indexOf(this.state.mode) !== -1 ? (
              <div
                style={{
                  marginTop: "1em",
                  marginBottom: "1em",
                  border: "2px dashed #ccc",
                  borderRadius: "1em",
                  maxWidth: 550,
                  padding: 20
                }}
              >
                <h2>Livestream setup</h2>
                <div style={{ marginTop: "1em" }}>
                  This screening includes a livestream. Nice! Configure your
                  livestream here. Once saved and configured, you can start a
                  livestream from the{" "}
                  <Link
                    to={`/event_buckets/${this.props.params.eventBucketId}/virtual_festival/live`}
                  >
                    livestreaming hub
                  </Link>
                  .
                </div>
                {this.state.mode === "combo" ? (
                  <div style={{ marginBottom: "1em" }}>
                    <TextField
                      value={get(
                        this.state,
                        "values._livestream_film.name",
                        ""
                      )}
                      floatingLabelText={"Livestream title"}
                      floatingLabelFixed={true}
                      style={{ width: "100%", maxWidth: 517 }}
                      onChange={e =>
                        this.onChangeValue(
                          "_livestream_film.name",
                          e.target.value
                        )
                      }
                    />

                    <TextField
                      value={get(
                        this.state,
                        "values._livestream_film.short_description",
                        ""
                      )}
                      floatingLabelText={"Livestream short/sidebar description"}
                      floatingLabelFixed={true}
                      multiLine={true}
                      style={{ display: "block", width: "100%", maxWidth: 517 }}
                      onChange={e =>
                        this.onChangeValue(
                          "_livestream_film.short_description",
                          e.target.value
                        )
                      }
                    />

                    <Label>Livestream description</Label>
                    <HtmlEditor
                      value={get(
                        this.state,
                        "values._livestream_film.description",
                        ""
                      )}
                      onChange={content =>
                        this.onChangeValue(
                          "_livestream_film.description",
                          content
                        )
                      }
                    />
                  </div>
                ) : null}

                <div style={{}}>
                  <DateTimeField
                    value={get(
                      this.state,
                      "values._livestream_film.start_time",
                      ""
                    )}
                    label={"Livestream start time"}
                    useMoment={true}
                    unclearable={true}
                    timezone={this.state.event.timezone}
                    onChange={(e, v) =>
                      this.onChangeValue("_livestream_film.start_time", v)
                    }
                    style={{ display: "inline-block", marginRight: 24 }}
                  />
                  <DateTimeField
                    value={get(
                      this.state,
                      "values._livestream_film.end_time",
                      ""
                    )}
                    label={"Livestream end time"}
                    useMoment={true}
                    unclearable={true}
                    timezone={this.state.event.timezone}
                    onChange={(e, v) =>
                      this.onChangeValue("_livestream_film.end_time", v)
                    }
                    style={{ display: "inline-block" }}
                  />
                </div>

                <div>
                  <Label>Livestream mode</Label>
                  <RadioButtonGroup
                    name="livestream_mode"
                    valueSelected={get(
                      this.state,
                      "values._livestream_film.livestream_mode",
                      ""
                    )}
                    onChange={(e, v) =>
                      this.onChangeValue("_livestream_film.livestream_mode", v)
                    }
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly"
                    }}
                  >
                    <RadioButton
                      value="eventive"
                      label="Eventive native secure livestream with live chat"
                      labelStyle={{ lineHeight: "20px" }}
                      style={{ display: "block" }}
                    />
                    <RadioButton
                      value="embedded"
                      label="Embedded player (e.g. YouTube; no live chat)"
                      labelStyle={{ lineHeight: "20px" }}
                      style={{ display: "block" }}
                    />
                    <RadioButton
                      value="external"
                      label="External instructions (no player or chat)"
                      labelStyle={{ lineHeight: "20px" }}
                      style={{ display: "block" }}
                    />
                  </RadioButtonGroup>
                </div>

                {get(
                  this.state,
                  "values._livestream_film.livestream_mode",
                  ""
                ) === "embedded" && (
                  <div>
                    <Label>Raw embed code (must be valid HTML)</Label>
                    <Codemirror
                      ref={r => r && r.getCodeMirror().setSize(null, 100)}
                      style={{ border: "1px solid #ccc" }}
                      value={get(
                        this.state,
                        "values._livestream_film.livestream_embed_code",
                        ""
                      )}
                      onChange={content =>
                        this.onChangeValue(
                          "_livestream_film.livestream_embed_code",
                          content
                        )
                      }
                      options={{
                        lineWrapping: true,
                        lineNumbers: true,
                        mode: { name: "htmlmixed" }
                      }}
                    />
                  </div>
                )}
                {get(
                  this.state,
                  "values._livestream_film.livestream_mode",
                  ""
                ) === "external" && (
                  <div>
                    <Label>External access instructions</Label>
                    <HtmlEditor
                      value={get(
                        this.state,
                        "values._livestream_film.livestream_external_instructions",
                        ""
                      )}
                      onChange={content =>
                        this.onChangeValue(
                          "_livestream_film.livestream_external_instructions",
                          content
                        )
                      }
                    />
                  </div>
                )}
              </div>
            ) : null}

            {event.is_virtual ? (
              <div>
                <Label>Availability window</Label>

                <RadioButtonGroup
                  name="is_dated"
                  valueSelected={(typeof this.state.values.is_dated !==
                  "undefined"
                    ? this.state.values.is_dated
                    : ""
                  ).toString()}
                  onChange={async (e, v) => {
                    await this.onChangeValueAsync("is_dated", v === "true");
                    if (v === "false") {
                      // If date restrictions are removed, ensure realtime broadcast is disabled
                      await this.onChangeValueAsync(
                        "virtual_realtime_broadcast_film",
                        false
                      );
                    }
                  }}
                >
                  <RadioButton
                    value={"false"}
                    label="No date restrictions on availability"
                  />
                  <RadioButton
                    value={"true"}
                    label="Restrict availability by date"
                  />
                </RadioButtonGroup>
              </div>
            ) : null}

            {(
              event.is_virtual
                ? this.state.values.is_dated
                : this.state.mode !== "undated"
            ) ? (
              <div style={event.is_virtual ? { marginLeft: "3em" } : {}}>
                <DateTimeField
                  value={this.state.values.start_time}
                  label={
                    this.state.values.virtual_realtime_broadcast_film
                      ? "Live broadcast begins"
                      : event.is_virtual
                      ? `Availability opens`
                      : "Start time"
                  }
                  useMoment={true}
                  unclearable={true}
                  timezone={this.state.event.timezone}
                  onChange={(e, v) => this.onChangeValue("start_time", v)}
                  style={{ display: "inline-block", marginRight: 24 }}
                />
                <DateTimeField
                  value={this.state.values.end_time}
                  label={
                    this.state.values.virtual_realtime_broadcast_film
                      ? this.state.values
                          .virtual_realtime_broadcast_become_vod_afterwards
                        ? "On-demand access closes"
                        : "Live broadcast ends"
                      : event.is_virtual
                      ? `Availability closes`
                      : "End time"
                  }
                  useMoment={true}
                  unclearable={true}
                  timezone={this.state.event.timezone}
                  onChange={(e, v) => this.onChangeValue("end_time", v)}
                  style={{ display: "inline-block" }}
                />
              </div>
            ) : null}
            {this.state.mode !== "undated" && !event.is_virtual ? (
              !this.state.event.recurring_event ? (
                <div style={{ marginTop: 0 }}>
                  <LinkLike
                    onTouchTap={() => this.setState({ showScheduler: true })}
                  >
                    Schedule event recurrence
                  </LinkLike>
                </div>
              ) : (
                <div>
                  <Label>Recurrence</Label>
                  {this.state.event.recurring_event &&
                    this.state.event.recurring_event.repeats &&
                    this.state.event.recurring_event.repeats.map(
                      ({ rrule, duration }) => {
                        const r = rrulestr(rrule);
                        const first = r.all((_, i) => i === 0);
                        const d = first.length ? first[0] : new Date();
                        const m = moment(appendTimeZone(d)).tz(
                          this.state.event.timezone
                        );
                        return (
                          <div>
                            {m.format("LT [– beginning] dddd, LL,")}{" "}
                            {r.toText()}
                          </div>
                        );
                      }
                    )}
                  <div>
                    <LinkLike
                      onTouchTap={() => this.setState({ showScheduler: true })}
                    >
                      Edit schedule
                    </LinkLike>
                  </div>
                </div>
              )
            ) : null}
            {event.is_virtual && this.state.values.is_dated ? (
              <div
                style={{
                  marginLeft: "2.75em",
                  marginTop: "0.25em",
                  marginBottom: "1em",
                  maxWidth: 700
                }}
              >
                <Checkbox
                  label={`Allow customers to pre-order this screening & receive an email reminder when it goes live`}
                  checked={get(this.state, "values.allow_preorder", false)}
                  onCheck={e =>
                    this.onChangeValue(
                      "allow_preorder",
                      !this.state.values.allow_preorder
                    )
                  }
                />
                <Checkbox
                  label={`Show in "Coming Soon" section in Catalog before screening becomes available`}
                  checked={get(this.state, "values.show_in_coming_soon", false)}
                  onCheck={e =>
                    this.onChangeValue(
                      "show_in_coming_soon",
                      !this.state.values.show_in_coming_soon
                    )
                  }
                />
                <Checkbox
                  label="Play VOD content as a single real-time broadcast"
                  checked={get(
                    this.state,
                    "values.virtual_realtime_broadcast_film",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "virtual_realtime_broadcast_film",
                      this.state.values.virtual_realtime_broadcast_film
                        ? false
                        : true
                    )
                  }
                />
                {this.state.values.virtual_realtime_broadcast_film ? (
                  <div
                    style={{
                      marginLeft: "3em",
                      marginTop: "0.5em",
                      maxWidth: 550,
                      border: "2px dashed #ccc",
                      padding: "10px 14px",
                      borderRadius: "0.25em"
                    }}
                  >
                    <div style={{ fontWeight: "bold", marginBottom: "0.2em" }}>
                      Eventive Real-Time Broadcasting
                    </div>
                    <div style={{ marginBottom: "0.2em" }}>
                      When you enable Real-Time Broadcasting, the program will
                      begin to play automatically at{" "}
                      <span>
                        {moment(this.state.values.start_time).format("lll")}
                      </span>{" "}
                      and play all pre-roll, all films, and finally all
                      post-roll elements, in that order. Viewers will not be
                      able to rewind or fast-forward. If viewers join late, they
                      will miss the beginning of the program. When the last item
                      has finished, the program will{" "}
                      {this.state.values
                        .virtual_realtime_broadcast_become_vod_afterwards
                        ? "become available for on-demand viewing until the availability window closes."
                        : "end and no longer be accessible to anyone."}
                    </div>
                    <div style={{ marginBottom: "0.2em" }}>
                      By default, a live chat will be available. You can
                      moderate, or disable it entirely, via the Livestreaming
                      hub.
                    </div>
                    <div style={{ marginBottom: "0.2em" }}>
                      Only media uploaded through the Eventive VOD secure
                      pathway is supported for DRM-protected real-time
                      broadcasting.{" "}
                      <strong>
                        Review the program order below to confirm what will be
                        played.
                      </strong>
                    </div>
                    {(() => {
                      const goodAssets = event.virtual_content_preroll
                        .map(k => VirtualContentStore.getVirtualContentById(k))
                        .filter(p => p && p.ams_drm_enabled)
                        .map(p => p.label)
                        .concat(
                          event.films
                            .filter(
                              f =>
                                f.virtual_content &&
                                f.virtual_content.ams_drm_enabled &&
                                f.virtual_content.status === "ready"
                            )
                            .map(f => f.name)
                        )
                        .concat(
                          event.virtual_content_postroll
                            .map(k =>
                              VirtualContentStore.getVirtualContentById(k)
                            )
                            .filter(p => p && p.ams_drm_enabled)
                            .map(p => p.label)
                        )
                        .join(", ");
                      const badAssets = event.virtual_content_preroll
                        .map(k => VirtualContentStore.getVirtualContentById(k))
                        .filter(p => p && !p.ams_drm_enabled)
                        .map(p => p.label)
                        .concat(
                          event.films
                            .filter(
                              f =>
                                !(
                                  f.virtual_content &&
                                  f.virtual_content.ams_drm_enabled &&
                                  f.virtual_content.status === "ready"
                                ) && f.type !== "livestream"
                            )
                            .map(f => f.name)
                        )
                        .concat(
                          event.virtual_content_postroll
                            .map(k =>
                              VirtualContentStore.getVirtualContentById(k)
                            )
                            .filter(p => p && !p.ams_drm_enabled)
                            .map(p => p.label)
                        )
                        .join(", ");

                      return (
                        <div style={{ marginBottom: "0.2em" }}>
                          Program order:{" "}
                          <strong>
                            {goodAssets}{" "}
                            {badAssets ? (
                              <div style={{ color: "red" }}>
                                *** DANGER: THE FOLLOWING ASSETS ARE NOT POWERED
                                BY EVENTIVE VOD AND WILL NOT BE INCLUDED IN THE
                                BROADCAST: {badAssets}
                              </div>
                            ) : null}
                          </strong>
                        </div>
                      );
                    })()}
                    <div style={{ marginBottom: "0em" }}>
                      Status:{" "}
                      {event.virtual_realtime_broadcast_film ? (
                        <strong>
                          Scheduled & going live{" "}
                          {moment(event.start_time).format("lll")}
                        </strong>
                      ) : (
                        <span>
                          <strong>Not scheduled</strong> (save to update)
                        </span>
                      )}
                    </div>
                    <div style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
                      <Checkbox
                        label={
                          <span>
                            After live broadcast concludes, make program
                            available for on-demand viewing until availability
                            window closes
                          </span>
                        }
                        labelStyle={{ lineHeight: "20px" }}
                        checked={get(
                          this.state,
                          "values.virtual_realtime_broadcast_become_vod_afterwards",
                          false
                        )}
                        onCheck={e =>
                          this.onChangeValue(
                            "virtual_realtime_broadcast_become_vod_afterwards",
                            !this.state.values
                              .virtual_realtime_broadcast_become_vod_afterwards
                          )
                        }
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {event.is_virtual ? (
              <div>
                <Label>Geographic availability</Label>

                <RadioButtonGroup
                  name="geo_availability"
                  valueSelected={
                    this.state.showGeographicRestrictions || "null"
                  }
                  onChange={(e, v) => {
                    if (v === "null") v = null;
                    this.setState({ showGeographicRestrictions: v }, () => {
                      if (v !== "geographic_restrictions") {
                        this.onChangeValue("geographic_restrictions", []);
                      }
                      if (v !== "geographic_exclusions") {
                        this.onChangeValue("geographic_exclusions", []);
                      }
                    });
                  }}
                >
                  <RadioButton
                    value={"null"}
                    label="No geographic restrictions"
                  />
                  <RadioButton
                    value={"geographic_restrictions"}
                    label="Only allow certain geographic regions"
                  />
                  <RadioButton
                    value={"geographic_exclusions"}
                    label="Allow all except certain geographic regions"
                  />
                </RadioButtonGroup>
              </div>
            ) : null}
            {this.state.showGeographicRestrictions ? (
              <div style={{ marginTop: "0.25em", marginLeft: "3em" }}>
                <div style={{ fontWeight: "bold", marginBottom: "0.5em" }}>
                  {this.state.showGeographicRestrictions ===
                  "geographic_restrictions"
                    ? `Only users located in the following regions will be allowed to
                  unlock the content:`
                    : `All users EXCEPT those located in the following regions will be allowed to
                  unlock the content:`}
                </div>
                <InjectedSelect
                  value={
                    this.state.values[this.state.showGeographicRestrictions]
                  }
                  types={["countries", "continents", "regions"]}
                  placeholderText={
                    this.state.showGeographicRestrictions ===
                    "geographic_restrictions"
                      ? "No authorized continents, countries, or provinces"
                      : `No blocked continents, countries, or provinces`
                  }
                  multi={true}
                  noResultsText={
                    <span>
                      No regions found. Try entering a continent, country, or
                      province, or{" "}
                      <LinkLike
                        onTouchTap={() =>
                          Intercom(
                            "showNewMessage",
                            "I'm looking to restrict by: "
                          )
                        }
                      >
                        get in touch with us
                      </LinkLike>
                      .
                    </span>
                  }
                  labelFormatter={v => v.name}
                  style={{ width: 400 }}
                  onChange={selected =>
                    this.onChangeValue(
                      this.state.showGeographicRestrictions,
                      selected
                    )
                  }
                  eventBucketId={this.props.params.eventBucketId}
                />
              </div>
            ) : null}

            <Label>Description</Label>
            {this.state.mode === "combo" ||
            this.state.mode === "vod" ||
            this.state.mode === "film" ? (
              <Checkbox
                style={{ marginBottom: "0.5em", maxWidth: 500 }}
                label="Add additional description in addition to film description"
                checked={
                  this.state.showDescription ||
                  this.state.values.description ||
                  this.state.values.short_description
                }
                onCheck={(e, checked) =>
                  this.setState({ showDescription: checked }, () => {
                    this.onChangeValue("description", "", () =>
                      this.onChangeValue("short_description", "")
                    );
                  })
                }
              />
            ) : null}
            {(this.state.mode !== "film" && !event.is_virtual) ||
            this.state.mode === "live" ||
            this.state.showDescription ||
            this.state.values.description ||
            this.state.values.short_description ? (
              <div>
                {typeof get(this.state, "values.description") === "string" ? (
                  <HtmlEditor
                    onChange={content =>
                      this.onChangeValue("description", content)
                    }
                    value={get(this.state, "values.description", "")}
                  />
                ) : null}
                <TextField
                  value={get(this.state, "values.short_description", "")}
                  floatingLabelText={"Short description"}
                  floatingLabelFixed={true}
                  multiLine={true}
                  style={{ display: "block", width: "100%", maxWidth: 517 }}
                  onChange={e =>
                    this.onChangeValue("short_description", e.target.value)
                  }
                />
                {this.state.mode !== "live" ? (
                  <div
                    style={{
                      fontSize: "0.8em",
                      marginTop: -5,
                      color: "rgb(158, 158, 158)"
                    }}
                  >
                    Not required. Used in schedule extended view as well as for
                    social media sharing.
                  </div>
                ) : null}
              </div>
            ) : null}
            {!event.is_virtual && (
              <div>
                <Label>Venue</Label>
                <InjectedSelect
                  value={this.state.values.venue}
                  type="venues"
                  noResultsText={
                    <span>
                      No venues found. Use the{" "}
                      <Link
                        to={`event_buckets/${this.props.params.eventBucketId}/venues`}
                      >
                        Venues
                      </Link>{" "}
                      section to create new venues.
                    </span>
                  }
                  labelFormatter={v => v.name}
                  eventBucketId={this.props.params.eventBucketId}
                  style={{ width: 300 }}
                  onChange={selected => {
                    this.setState({ hasVenueChanged: selected !== this.state.oldVenue });  
                    this.onChangeValue("venue", selected);
                  }}
                />
              </div>
            )}
            {!event.is_virtual && this.state.hasReservedSeating && this.state.hasVenueChanged ? (
              <div style={{ color: "#f00", fontSize: 11, fontWeight: "bold" }}>
                WARNING: If you change the venue after tickets have been sold for this event,
                some customers may lose the reserved seats they have chosen.
              </div>
            ) : null}
            <div style={event.is_virtual ? { marginBottom: "1em" } : {}}>
              <Label>{event.is_virtual ? "Display sections" : "Tags"}</Label>
              {this.state.mode === "film" ? (
                <Checkbox
                  style={{ marginBottom: "0.5em" }}
                  label="Add additional tags in addition to film tags"
                  checked={this.state.showTags || this.state.values.tags.length}
                  onCheck={(e, checked) =>
                    this.setState({ showTags: checked }, () => {
                      this.onChangeValue("tags", []);
                    })
                  }
                />
              ) : null}
              {event.is_virtual ||
              this.state.mode !== "film" ||
              this.state.showTags ||
              this.state.values.tags.length ? (
                <InjectedSelect
                  value={get(this.state.values, "tags", [])}
                  types={["tags"]}
                  multi={true}
                  noResultsText={
                    <span>
                      No tags found. Use the{" "}
                      <Link
                        to={`event_buckets/${this.props.params.eventBucketId}/tags`}
                      >
                        Tags
                      </Link>{" "}
                      section to create new tags.
                    </span>
                  }
                  labelFormatter={t => t.name}
                  eventBucketId={this.props.params.eventBucketId}
                  style={{ width: 500 }}
                  onChange={selected => this.onChangeValue("tags", selected)}
                />
              ) : null}
            </div>
            {!event.is_virtual ||
            (this.state.event &&
              this.state.event.images &&
              this.state.event.images.cover) ? (
              <div>
                <Label>Cover image</Label>
                {(
                  event.is_virtual
                    ? this.state.mode === "vod" || this.state.mode === "combo"
                    : this.state.mode === "film"
                ) ? (
                  <Checkbox
                    style={{ marginBottom: "0.5em" }}
                    label="Show a custom cover image instead of default film cover image"
                    checked={
                      this.state.showCoverImage ||
                      (this.state.event &&
                        this.state.event.images &&
                        this.state.event.images.cover)
                    }
                    onCheck={(e, checked) =>
                      this.setState({ showCoverImage: checked }, () => {
                        this.state.event.images.cover = null;
                        this.setState(this.state, () => {
                          if (!this.state.showCoverImage) {
                            this.onChangeValue("image", null);
                          }
                        });
                      })
                    }
                  />
                ) : null}
                {this.state.showCoverImage ||
                this.state.mode !== "film" ||
                (this.state.event &&
                  this.state.event.images &&
                  this.state.event.images.cover) ? (
                  <div>
                    {this.props.uploadingImageField === "image" ? (
                      <div>
                        <CircularProgress
                          style={styles.progress}
                          mode="indeterminate"
                        />
                      </div>
                    ) : null}
                    <div
                      style={{
                        display:
                          this.props.uploadingImageField === "image"
                            ? "none"
                            : "block"
                      }}
                    >
                      {this.state.event &&
                      this.state.event.images &&
                      this.state.event.images.cover ? (
                        <img src={this.state.event.images.cover} width={242} />
                      ) : null}
                      <ImageDropzone
                        style={styles.dropzone}
                        onDrop={([f]) => this.onDrop("image", f)}
                        crop={{ width: 960, height: 380 }}
                      >
                        <div>
                          To add a new cover image, drop a file here, or click
                          to select.
                        </div>
                      </ImageDropzone>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {event.is_virtual ? (
              <div>
                <Label>Still image</Label>
                <Checkbox
                  style={{ marginBottom: "0.5em" }}
                  label={`Show a custom still image on the screening page${
                    this.state.mode !== "live"
                      ? " instead of default film image"
                      : ""
                  }`}
                  checked={
                    this.state.showStillImage ||
                    (this.state.event &&
                      this.state.event.images &&
                      this.state.event.images.still)
                  }
                  onCheck={(e, checked) =>
                    this.setState({ showStillImage: checked }, () => {
                      this.state.event.images.still = null;
                      this.setState(this.state, () => {
                        if (!this.state.showStillImage) {
                          this.onChangeValue("still_image", null);
                        }
                      });
                    })
                  }
                />
                {this.state.showStillImage ||
                (this.state.event &&
                  this.state.event.images &&
                  this.state.event.images.still) ? (
                  <div>
                    {this.props.uploadingImageField === "still_image" ? (
                      <div>
                        <CircularProgress
                          style={styles.progress}
                          mode="indeterminate"
                        />
                      </div>
                    ) : null}
                    <div
                      style={{
                        display:
                          this.props.uploadingImageField === "still_image"
                            ? "none"
                            : "block"
                      }}
                    >
                      {this.state.event &&
                      this.state.event.images &&
                      this.state.event.images.still ? (
                        <img src={this.state.event.images.still} width={242} />
                      ) : null}
                      <ImageDropzone
                        style={styles.dropzone}
                        onDrop={([f]) => this.onDrop("still_image", f)}
                        crop={{ width: 1920, height: 1080 }}
                        hideCropTip
                      >
                        <div>
                          To add a new still image, drop a file here, or click
                          to select.{" "}
                          <div
                            style={{
                              marginTop: "0.5em",
                              fontSize: "0.9em",
                              lineHeight: 1.3
                            }}
                          >
                            Recommended: 1920 x 1080px; will be cropped to 16:9
                            aspect ratio.
                          </div>
                        </div>
                      </ImageDropzone>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {event.is_virtual ? (
              <div>
                <Label>Display ads</Label>
                <Checkbox
                  style={{ marginBottom: "0.5em" }}
                  label="Show custom display ad(s) on the screening page"
                  checked={
                    this.state.event &&
                    this.state.event.display_ads &&
                    this.state.event.display_ads.length > 0
                  }
                  onCheck={(e, checked) => {
                    let newAdState = [];
                    if (checked) {
                      newAdState = [{ url: null, image: null }];
                    }
                    this.state.event.display_ads = newAdState;
                    this.setState(this.state, () => {
                      this.onChangeValue("display_ads", newAdState);
                    });
                  }}
                />
                {this.state.event &&
                this.state.event.display_ads &&
                this.state.event.display_ads.length > 0 ? (
                  <DisplayAdEditor
                    ads={this.state.event.display_ads}
                    onUpdate={adState => {
                      this.onChangeValue("display_ads", adState);
                    }}
                  />
                ) : null}
              </div>
            ) : null}
            {(
              event.is_virtual
                ? this.state.mode !== "vod" && this.state.mode !== "combo"
                : this.state.mode !== "film"
            ) ? (
              <div style={event.is_virtual ? { marginTop: "-0.5em" } : {}}>
                <TextField
                  style={{ width: 300 }}
                  value={this.state.values.trailer_url || ""}
                  floatingLabelText="Trailer URL"
                  floatingLabelFixed={true}
                  placeholder="YouTube, Vimeo, Facebook Video link"
                  onChange={e =>
                    this.onChangeValue("trailer_url", e.target.value)
                  }
                />
              </div>
            ) : null}
            <div>
              <Label>Visibility</Label>
              <RadioButtonGroup
                name="visibility"
                valueSelected={this.state.values.visibility}
                onChange={(e, v) => this.onChangeValue("visibility", v)}
              >
                {[
                  <RadioButton
                    value="visible"
                    label="Visible (if schedule is enabled)"
                  />,
                  <RadioButton value="hidden" label="Hidden from public" />,
                  !event.is_virtual && (
                    <RadioButton
                      value="tba"
                      label={`Show as "To Be Announced"`}
                    />
                  )
                ].filter(x => !!x)}
              </RadioButtonGroup>
            </div>
            <Label>Custom confirmation email message</Label>
            <Checkbox
              style={{ marginBottom: "0.5em" }}
              label="Add custom message to confirmation email"
              checked={
                this.state.showCustomEmailText ||
                this.state.values.custom_email_text
              }
              onCheck={(e, checked) =>
                this.setState({ showCustomEmailText: checked }, () => {
                  this.onChangeValue("custom_email_text", "");
                })
              }
            />
            {this.state.showCustomEmailText ||
            this.state.values.custom_email_text ? (
              <div>
                <HtmlEditor
                  onChange={content => {
                    this.onChangeValue("custom_email_text", content);
                  }}
                  value={get(this.state, "values.custom_email_text", "")}
                />
              </div>
            ) : null}
            <div>
              <Label>Passholder tickets</Label>
              <Checkbox
                label="Use default event bucket setting"
                checked={
                  this.state.values.passholder_ticket_required === "default"
                }
                onCheck={(e, checked) =>
                  this.onChangeValue(
                    "passholder_ticket_required",
                    checked ? "default" : ""
                  )
                }
              />
              {this.state.values.passholder_ticket_required !== "default" ? (
                <RadioButtonGroup
                  name="passholder_ticket_required"
                  valueSelected={(typeof this.state.values
                    .passholder_ticket_required !== "undefined"
                    ? this.state.values.passholder_ticket_required
                    : ""
                  ).toString()}
                  onChange={(e, v) =>
                    this.onChangeValue("passholder_ticket_required", v)
                  }
                >
                  <RadioButton
                    value="true"
                    label={
                      'Require passholder ticket reservation in advance ("RSVP")'
                    }
                    disabled={
                      this.state.values.passholder_ticket_required === "default"
                    }
                  />
                  <RadioButton
                    value="false"
                    label="Do not require advance reservation; allow passholder walk-ups"
                    disabled={
                      this.state.values.passholder_ticket_required === "default"
                    }
                  />
                </RadioButtonGroup>
              ) : null}
            </div>
            <div>
              <Label>Standalone tickets</Label>
              <Checkbox
                label="Use default event bucket setting"
                checked={
                  this.state.values.standalone_ticket_sales_enabled ===
                  "default"
                }
                onCheck={(e, checked) =>
                  this.onChangeValue(
                    "standalone_ticket_sales_enabled",
                    checked ? "default" : ""
                  )
                }
              />
              {this.state.values.standalone_ticket_sales_enabled !==
              "default" ? (
                <RadioButtonGroup
                  name="standalone_ticket_sales_enabled"
                  valueSelected={(typeof this.state.values
                    .standalone_ticket_sales_enabled !== "undefined"
                    ? this.state.values.standalone_ticket_sales_enabled
                    : ""
                  ).toString()}
                  onChange={(e, v) =>
                    this.onChangeValue("standalone_ticket_sales_enabled", v)
                  }
                >
                  <RadioButton
                    value="true"
                    label="Allow standalone ticket sales"
                    disabled={
                      this.state.values.standalone_ticket_sales_enabled ===
                      "default"
                    }
                  />
                  <RadioButton
                    value="false"
                    label="Disable standalone tickets sales (only allow passholders)"
                    disabled={
                      this.state.values.standalone_ticket_sales_enabled ===
                      "default"
                    }
                  />
                </RadioButtonGroup>
              ) : null}
              {(
                EventBucketStore.getEventBucketById(
                  this.props.params.eventBucketId
                ) || {}
              ).standalone_ticket_sales_locked ? (
                <div>
                  <div
                    style={{ marginTop: 10, marginBottom: 5, maxWidth: 525 }}
                  >
                    Currently, standalone ticket sales are locked with a
                    password for this event's event bucket. You can override
                    this lock (for this event only) below.
                  </div>
                  <Checkbox
                    label={
                      "Unlock standalone ticket sales (no password required)"
                    }
                    checked={
                      this.state.values.standalone_ticket_sales_unlocked ||
                      false
                    }
                    onCheck={this.onChange.bind(
                      this,
                      "standalone_ticket_sales_unlocked"
                    )}
                  />
                </div>
              ) : null}
            </div>
            {event.is_virtual ? (
              <div>
                <Label>Pre-roll virtual content</Label>
                <Checkbox
                  label="Use default event bucket setting"
                  checked={this.state.values.use_default_event_bucket_preroll}
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "use_default_event_bucket_preroll",
                      checked
                    )
                  }
                />
                {!this.state.values.use_default_event_bucket_preroll ? (
                  <div>
                    <RadioButtonGroup
                      name="virtual_content_preroll_visible"
                      valueSelected={(typeof this.state.values
                        .virtual_content_preroll_visible !== "undefined"
                        ? this.state.values.virtual_content_preroll_visible
                        : ""
                      ).toString()}
                      onChange={(e, v) =>
                        this.onChangeValue(
                          "virtual_content_preroll_visible",
                          v === "true"
                        )
                      }
                    >
                      <RadioButton
                        value="true"
                        label={"Custom pre-roll for this screening"}
                      />
                      <RadioButton
                        value="false"
                        label="Disable all pre-roll on this screening"
                      />
                    </RadioButtonGroup>
                    {this.state.values.virtual_content_preroll_visible ? (
                      <div
                        style={{
                          width: "100%",
                          overflowX: "auto",
                          margin: "1em 0"
                        }}
                      >
                        <VirtualContentEditor
                          style={{ width: "min-content", margin: "0 -10px" }}
                          useBeta={get(
                            eventBucket,
                            "virtual_festival_config.use_beta_vod_flow"
                          )}
                          value={this.state.values.virtual_content_preroll}
                          onChange={v =>
                            this.onChangeValue("virtual_content_preroll", v)
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}
            {event.is_virtual ? (
              <div>
                <Label>Post-roll virtual content</Label>
                <Checkbox
                  label="Use default event bucket setting"
                  checked={this.state.values.use_default_event_bucket_postroll}
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "use_default_event_bucket_postroll",
                      checked
                    )
                  }
                />
                {!this.state.values.use_default_event_bucket_postroll ? (
                  <div>
                    <RadioButtonGroup
                      name="virtual_content_postroll_visible"
                      valueSelected={(typeof this.state.values
                        .virtual_content_postroll_visible !== "undefined"
                        ? this.state.values.virtual_content_postroll_visible
                        : ""
                      ).toString()}
                      onChange={(e, v) =>
                        this.onChangeValue(
                          "virtual_content_postroll_visible",
                          v === "true"
                        )
                      }
                    >
                      <RadioButton
                        value="true"
                        label={"Custom post-roll for this screening"}
                      />
                      <RadioButton
                        value="false"
                        label="Disable all post-roll on this screening"
                      />
                    </RadioButtonGroup>
                    {this.state.values.virtual_content_postroll_visible ? (
                      <div
                        style={{
                          width: "100%",
                          overflowX: "auto",
                          margin: "1em 0"
                        }}
                      >
                        <VirtualContentEditor
                          style={{ width: "min-content", margin: "0 -10px" }}
                          useBeta={get(
                            eventBucket,
                            "virtual_festival_config.use_beta_vod_flow"
                          )}
                          value={this.state.values.virtual_content_postroll}
                          onChange={v =>
                            this.onChangeValue("virtual_content_postroll", v)
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}

            {event.is_virtual ? (
              <div>
                <Label>Donations at checkout</Label>
                <Checkbox
                  label="Use default event bucket setting"
                  checked={
                    this.state.values.virtual_show_donate_prompt === "default"
                  }
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "virtual_show_donate_prompt",
                      checked ? "default" : true
                    )
                  }
                />
                {this.state.values.virtual_show_donate_prompt !== "default" ? (
                  <RadioButtonGroup
                    name="virtual_show_donate_prompt"
                    valueSelected={(typeof this.state.values
                      .virtual_show_donate_prompt !== "undefined"
                      ? this.state.values.virtual_show_donate_prompt
                      : ""
                    ).toString()}
                    onChange={(e, v) =>
                      this.onChangeValue(
                        "virtual_show_donate_prompt",
                        v === "true"
                      )
                    }
                  >
                    <RadioButton
                      value="true"
                      label={"Request donations at checkout"}
                      disabled={
                        this.state.values.virtual_show_donate_prompt ===
                        "default"
                      }
                    />
                    <RadioButton
                      value="false"
                      label="Do not request donations at checkout"
                      disabled={
                        this.state.values.virtual_show_donate_prompt ===
                        "default"
                      }
                    />
                  </RadioButtonGroup>
                ) : null}
                {this.state.values.virtual_show_donate_prompt === true ? (
                  <TextField
                    style={{ width: 400 }}
                    multiLine
                    value={
                      this.state.values.virtual_donate_message ||
                      (
                        EventBucketStore.getEventBucketById(
                          this.props.params.eventBucketId
                        ) || { frontend_config: {} }
                      ).frontend_config.virtual_festival_donate_message
                    }
                    floatingLabelText="Custom donation prompt message"
                    floatingLabelFixed={true}
                    onChange={e =>
                      this.onChangeValue(
                        "virtual_donate_message",
                        e.target.value
                      )
                    }
                  />
                ) : null}
              </div>
            ) : null}

            {event.is_virtual && (
              <div>
                <Label>Unlock/watch interval</Label>
                <Checkbox
                  label="Use default event bucket setting"
                  checked={!this.state.values.virtual_intervals}
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "virtual_intervals",
                      checked
                        ? null
                        : {
                            unlock_interval: get(
                              eventBucket,
                              "virtual_festival_config.unlock_interval"
                            ),
                            watch_interval: get(
                              eventBucket,
                              "virtual_festival_config.watch_interval"
                            )
                          }
                    )
                  }
                />
                {!!this.state.values.virtual_intervals && (
                  <div>
                    <DurationField
                      value={get(
                        this.state,
                        "values.virtual_intervals.unlock_interval",
                        ""
                      )}
                      floatingLabelText="Unlock window"
                      floatingLabelFixed={true}
                      onChange={e =>
                        this.onChangeValue(
                          "virtual_intervals.unlock_interval",
                          e.target.value
                        )
                      }
                    />
                    <DurationField
                      style={{ marginLeft: "1em" }}
                      value={get(
                        this.state,
                        "values.virtual_intervals.watch_interval",
                        ""
                      )}
                      floatingLabelText="Watch window"
                      floatingLabelFixed={true}
                      onChange={e =>
                        this.onChangeValue(
                          "virtual_intervals.watch_interval",
                          e.target.value
                        )
                      }
                    />
                  </div>
                )}
              </div>
            )}

            {event.is_virtual && eventBucket && eventBucket.frontend_config && eventBucket.frontend_config.use_aarp_registration_flow && (
              <div>
                <Label>AARP Membership Requirement</Label>
                <Checkbox
                  label="Require AARP Membership to access screening"
                  checked={this.state.values.aarp_member_required}
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "aarp_member_required",
                      !this.state.values.aarp_member_required
                    )
                  }
                />
              </div>
            )}

            {event.is_virtual ? (
              <div style={{ maxWidth: 600 }}>
                <Label>Miscellaneous</Label>
                {(
                  EventBucketStore.getEventBucketById(
                    this.props.params.eventBucketId
                  ) || {}
                ).credits_enabled ? (
                  <div style={{ maxWidth: 400 }}>
                    <Checkbox
                      label="Don't allow credits to be used"
                      checked={get(
                        this.state,
                        "values.credits_disabled",
                        false
                      )}
                      onCheck={e =>
                        this.onChangeValue(
                          "credits_disabled",
                          !this.state.values.credits_disabled
                        )
                      }
                    />
                  </div>
                ) : null}
                <Checkbox
                  label={`Show an "unlocks remaining" quantity countdown on the screening page`}
                  checked={get(
                    this.state,
                    "values.show_quantity_countdown",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "show_quantity_countdown",
                      !this.state.values.show_quantity_countdown
                    )
                  }
                />
                <Checkbox
                  label={`Enable virtual balloting for this screening`}
                  checked={get(
                    this.state,
                    "values.virtual_balloting_enabled",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "virtual_balloting_enabled",
                      !this.state.values.virtual_balloting_enabled
                    )
                  }
                />
                {window.location.search.indexOf("beta=1") !== -1 &&
                this.state.values.virtual_balloting_enabled ? (
                  <Checkbox
                    label={`[BETA] Show balloting inline below player`}
                    checked={get(
                      this.state,
                      "values.virtual_balloting_inline_during_playback",
                      false
                    )}
                    onCheck={e =>
                      this.onChangeValue(
                        "virtual_balloting_inline_during_playback",
                        !this.state.values
                          .virtual_balloting_inline_during_playback
                      )
                    }
                  />
                ) : null}
                <div>
                  <Checkbox
                    label={'Use custom text for "Unlock" button'}
                    checked={this.state.showTicketsButtonLabel}
                    onCheck={this.onTicketsButtonLabelCheck}
                  />
                  {this.state.showTicketsButtonLabel ? (
                    <TextField
                      value={this.state.values.tickets_button_label || ""}
                      floatingLabelText={`"Unlock now" button label`}
                      floatingLabelFixed={true}
                      placeholder="Unlock now"
                      style={{ marginTop: "-0.75em", marginLeft: "2.5em" }}
                      onChange={e =>
                        this.onChangeValue(
                          "tickets_button_label",
                          e.target.value
                        )
                      }
                    />
                  ) : null}
                </div>
                {this.renderExternalTicketsUrl()}
                <Checkbox
                  label="Sales locked: Require customers to first enter a valid discount code in order to unlock"
                  checked={get(
                    this.state,
                    "values.sales_disabled_unless_coupon",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "sales_disabled_unless_coupon",
                      !this.state.values.sales_disabled_unless_coupon
                    )
                  }
                />
                {UserStore.isGod() && event.is_virtual ? (
                  <Checkbox
                  label="[GOD ONLY] Cut off watch window immediately at availability window end for this event"
                  checked={get(
                    this.state,
                    "values.cutoff_event_watch_at_availability_end",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "cutoff_event_watch_at_availability_end",
                      !this.state.values.cutoff_event_watch_at_availability_end
                    )
                  }
                />
                ) : null}
              </div>
            ) : null}

            {!event.is_virtual ? (
              <div style={{ maxWidth: 400 }}>
                <Label>Miscellaneous</Label>
                <Checkbox
                  label={'Hide "Order Tickets" button'}
                  checked={this.state.values.hide_tickets_button || false}
                  onCheck={this.onChange.bind(this, "hide_tickets_button")}
                />
                {!this.state.values.hide_tickets_button ? (
                  <div>
                    <Checkbox
                      label={'Custom label for "Order Tickets" button'}
                      checked={this.state.showTicketsButtonLabel}
                      onCheck={this.onTicketsButtonLabelCheck}
                    />
                    {this.state.showTicketsButtonLabel ? (
                      <TextField
                        value={this.state.values.tickets_button_label || ""}
                        floatingLabelText={`"Order Tickets" button label`}
                        floatingLabelFixed={true}
                        placeholder="Order Tickets"
                        style={{ marginTop: "-0.75em", marginLeft: "2.5em" }}
                        onChange={e =>
                          this.onChangeValue(
                            "tickets_button_label",
                            e.target.value
                          )
                        }
                      />
                    ) : null}
                  </div>
                ) : null}
                <Checkbox
                  label="Require customer mailing address"
                  checked={get(
                    this.state,
                    "values.require_mailing_address",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "require_mailing_address",
                      !this.state.values.require_mailing_address
                    )
                  }
                />
                <Checkbox
                  label="Require customer phone number"
                  checked={get(
                    this.state,
                    "values.require_phone_number",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "require_phone_number",
                      !this.state.values.require_phone_number
                    )
                  }
                />
                <Checkbox
                  label="Sales locked: Require customers to first enter a valid discount code in order to buy tickets"
                  checked={get(
                    this.state,
                    "values.sales_disabled_unless_coupon",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "sales_disabled_unless_coupon",
                      !this.state.values.sales_disabled_unless_coupon
                    )
                  }
                />
                {(
                  EventBucketStore.getEventBucketById(
                    this.props.params.eventBucketId
                  ) || {}
                ).credits_enabled ? (
                  <Checkbox
                    label="Don't allow credits to be used"
                    checked={get(this.state, "values.credits_disabled", false)}
                    onCheck={e =>
                      this.onChangeValue(
                        "credits_disabled",
                        !this.state.values.credits_disabled
                      )
                    }
                  />
                ) : null}
                {this.renderExternalTicketsUrl()}
                <Checkbox
                  label="Require agreement to a waiver/terms of use before placing order"
                  checked={showTermsEditor}
                  onCheck={(e, checked) => {
                    this.setState({ showTermsEditor: checked }, () => {
                      if (!this.state.showTermsEditor) {
                        this.onChangeValue("terms_at_checkout", "");
                      }
                    });
                  }}
                />
                {showTermsEditor ? (
                  <BasicHtmlField
                    label="Waiver message to display"
                    value={get(this.state, "values.terms_at_checkout", "")}
                    onChange={v => this.onChangeValue("terms_at_checkout", v)}
                  />
                ) : null}
              </div>
            ) : null}
            {this.state.showExternalTicketsUrl ? (
              <div style={styles.editor}>
                <h2 style={styles.editorHeader}>Ticket buckets</h2>
                <p>
                  You cannot add ticket buckets when an external tickets url is
                  set. To edit ticket buckets, disable "Sell tickets on external
                  site" above.
                </p>
              </div>
            ) : (
              <div style={styles.editor}>
                <h2 style={styles.editorHeader}>Ticket buckets</h2>
                <TicketBucketsEditor
                  onShiftPosition={(index, direction) =>
                    this.onArrayItemShiftPosition(
                      "ticket_buckets",
                      index,
                      direction
                    )
                  }
                  onAdd={e => this.onArrayItemAdd("ticket_buckets", e)}
                  onAddAndDelete={e => {
                    this.onArrayItemAddAndDelete(
                      "ticket_buckets",
                      e.additions,
                      e.delIndexes
                    );
                  }}
                  onEdit={(index, value) =>
                    this.onArrayItemEdit("ticket_buckets", index, value)
                  }
                  onDelete={index => {
                    this.onArrayItemDelete("ticket_buckets", index);
                  }}
                  event={this.props.params.eventId}
                  eventDetails={event}
                  ticketBuckets={this.state.values.ticket_buckets.map(b => ({
                    ...b,
                    event_bucket: this.state.event.event_bucket
                  }))}
                  venueDetails={VenueStore.getVenueById(
                    this.state.values.venue
                  )}
                />
              </div>
            )}
            {this.state.showExternalTicketsUrl ? (
              <div style={styles.editor}>
                <h2 style={styles.editorHeader}>Pass rules override</h2>
                <p>
                  You cannot add pass rule overides when an external tickets url
                  is set. To edit pass rules, disable "Sell tickets on external
                  site" above.
                </p>
              </div>
            ) : (
              <div style={styles.editor}>
                <h2 style={styles.editorHeader}>Pass rules override</h2>
                <PassRulesEditorNonAtomic
                  mode="event"
                  parentId={this.props.params.eventId}
                  parent={this.state.event}
                  eventBucketId={this.props.params.eventBucketId}
                  eventBucket={this.state.event.event_bucket}
                  onAdd={e => this.onArrayItemAdd("rules", e)}
                  onChange={(index, value) =>
                    this.onArrayItemEdit("rules", index, value)
                  }
                  onDelete={index => this.onArrayItemDelete("rules", index)}
                  getEventBucketById={EventBucketStore.getEventBucketById}
                  passRules={this.state.values.rules}
                />
              </div>
            )}
            <div style={styles.editor}>
              <h2 style={styles.editorHeader}>Revenue sharing</h2>
              <RevenueSharingEditor
                event={this.state.event}
                revenueShare={this.state.values.revenue_share}
                onChange={revenueShare => {
                  this.onChangeValue("revenue_share", revenueShare);
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Event);



// WEBPACK FOOTER //
// ./src/app/components/event-editor.jsx